import { render, staticRenderFns } from "./ChooseScreen.vue?vue&type=template&id=7bb5c535&scoped=true"
import script from "./ChooseScreen.vue?vue&type=script&lang=ts"
export * from "./ChooseScreen.vue?vue&type=script&lang=ts"
import style0 from "./ChooseScreen.vue?vue&type=style&index=0&id=7bb5c535&prod&lang=scss"
import style1 from "./ChooseScreen.vue?vue&type=style&index=1&id=7bb5c535&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bb5c535",
  null
  
)

export default component.exports